import { render, staticRenderFns } from "./FollowUpPatientStep6Component.vue?vue&type=template&id=d5ed3eca&scoped=true&"
import script from "./FollowUpPatientStep6Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep6Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep6Component.vue?vue&type=style&index=0&id=d5ed3eca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ed3eca",
  null
  
)

export default component.exports